/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum TokenStandard {
  NonFungible,
  FungibleAsset,
  Fungible,
  NonFungibleEdition,
}

export type TokenStandardArgs = TokenStandard;

export function getTokenStandardEncoder(): FixedSizeEncoder<TokenStandardArgs> {
  return getEnumEncoder(TokenStandard);
}

export function getTokenStandardDecoder(): FixedSizeDecoder<TokenStandard> {
  return getEnumDecoder(TokenStandard);
}

export function getTokenStandardCodec(): FixedSizeCodec<
  TokenStandardArgs,
  TokenStandard
> {
  return combineCodec(getTokenStandardEncoder(), getTokenStandardDecoder());
}
